var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.234375,
    y: 0.140625,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#06BA63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_58318)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.0838 7.14062H15.583C10.2987 7.14062 7.30469 10.1346 7.30469 15.4189V29.906C7.30469 35.1903 10.2987 38.1843 15.583 38.1843H30.0838C35.3682 38.1843 38.3484 35.1903 38.3484 29.906V15.4189C38.3484 10.1346 35.3682 7.14062 30.0838 7.14062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2293 22.0391V27.6825H26.5859",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2332 27.6811L25.5957 21.0436C25.4792 20.9271 25.341 20.8346 25.1888 20.7715C25.0366 20.7085 24.8734 20.676 24.7087 20.676C24.5439 20.676 24.3808 20.7085 24.2286 20.7715C24.0763 20.8346 23.9381 20.9271 23.8216 21.0436L21.2064 23.6588C21.0899 23.7753 20.9517 23.8678 20.7995 23.9308C20.6473 23.9939 20.4841 24.0264 20.3194 24.0264C20.1546 24.0264 19.9915 23.9939 19.8393 23.9308C19.687 23.8678 19.5488 23.7753 19.4323 23.6588L13.4219 17.6484",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_58318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(7.23438 7.14062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv5);
export default __webpack_public_path__ + "static/media/div5.9592cbaf6d2f48be2261a0b350f3bb60.svg";
export { ForwardRef as ReactComponent };